import { Component, Inject, OnDestroy, OnInit } from '@angular/core';
import { CardsNgrxFacade, RelatedCardFacade } from '@ridango/components';
import { ActivatedRoute, Router } from '@angular/router';
import { BaseComponent } from '@ridango/core';
import Env from '@ridango/core/env';
import { take } from 'rxjs/operators';

@Component({
    templateUrl: './cards-landing-page.component.html'
})
export class CardsLandingPageComponent extends BaseComponent implements OnInit, OnDestroy {
    constructor(
        private cardsFacade: CardsNgrxFacade,
        private relatedCardFacade: RelatedCardFacade,
        private router: Router,
        private route: ActivatedRoute,
        @Inject('ENV') public env: Env
    ) {
        super();
    }

    ngOnInit() {
        this.cardsFacade.fetchCustomerCards();
        this.relatedCardFacade.loaded$.pipe(take(1)).subscribe((loaded) => {
            if (!loaded) {
                this.relatedCardFacade.fetchAllRelatedCards();
            }
        });
    }

    ngOnDestroy() {
        super.ngOnDestroy();
    }

    navigateToAddCard() {
        this.router.navigate([`add`], { relativeTo: this.route.parent });
    }
}
